import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton, Tooltip } from '@mui/material'

type Props = {
  id: number | string
  onDelete: (id: string | number) => void
  tooltipTitle?: string
  locked?: boolean
}

export const IconButtonDelete = (props: Props) => {
  const tooltipTitle = props.tooltipTitle || 'Remove item'
  const disabled = !!props.locked

  if (disabled)
    return (
      <IconButton disabled={true}>
        <DeleteIcon />
      </IconButton>
    )

  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation()
          props.onDelete(props.id)
        }}
      >
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  )
}
